"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.setF24OrdinarioSetSezioneAltriEntiILRigaCodiceDitta = exports.setF24OrdinarioSetSezioneAltriEntiILRigaCodiceSede = exports.setF24OrdinarioSetSezioneImuRigaImportoCredito = exports.setF24OrdinarioSetSezioneImuRigaImportoDebito = exports.setF24OrdinarioSetSezioneImuRigaAnnoRiferimento = exports.setF24OrdinarioSetSezioneImuRigaRateazione = exports.setF24OrdinarioSetSezioneImuRigaCodiceTributo = exports.setF24OrdinarioSetSezioneImuRigaNI = exports.setF24OrdinarioSetSezioneImuRigaS = exports.setF24OrdinarioSetSezioneImuRigaA = exports.setF24OrdinarioSetSezioneImuRigaIV = exports.setF24OrdinarioSetSezioneImuRigaR = exports.setF24OrdinarioSetSezioneImuRigaCodiceRegione = exports.setF24OrdinarioSetSezioneImuDetrazione = exports.setF24OrdinarioSetSezioneRegioniRigaImportoCredito = exports.setF24OrdinarioSetSezioneRegioniRigaImportoDebito = exports.setF24OrdinarioSetSezioneRegioniRigaAnnoRiferimento = exports.setF24OrdinarioSetSezioneRegioniRigaRateazione = exports.setF24OrdinarioSetSezioneRegioniRigaCodiceTributo = exports.setF24OrdinarioSetSezioneRegioniRigaCodiceRegione = exports.setF24OrdinarioSetSezioneInpsRigaImportoCredito = exports.setF24OrdinarioSetSezioneInpsRigaImportoDebito = exports.setF24OrdinarioSetSezioneInpsRigaPeriodoA = exports.setF24OrdinarioSetSezioneInpsRigaPeriodoDa = exports.setF24OrdinarioSetSezioneInpsRigaMatricolaINPS = exports.setF24OrdinarioSetSezioneInpsRigaCausaleContributo = exports.setF24OrdinarioSetSezioneInpsRigaCodiceSede = exports.setF24OrdinarioSetSezioneErarioRigaImportoCredito = exports.setF24OrdinarioSetSezioneErarioRigaImportoDebito = exports.setF24OrdinarioSetSezioneErarioRigaAnnoDiRiferimento = exports.setF24OrdinarioSetSezioneErarioRigaRateazione = exports.setF24OrdinarioSetSezioneErarioRigaCodiceTributo = exports.setF24OrdinarioSetSezioneErarioCodiceUfficio = exports.setF24OrdinarioSetSezioneErarioCodiceAtto = exports.setF24OrdinarioSetContribuenteCodiceIdentificativoCoobligato = exports.setF24OrdinarioSetContribuenteCodiceFiscaleCoobligato = exports.setF24OrdinarioSetContribuenteDomicilioFiscaleViaECivico = exports.setF24OrdinarioSetContribuenteDomicilioFiscaleProvincia = exports.setF24OrdinarioSetContribuenteDomicilioFiscaleComune = exports.setF24OrdinarioSetContribuenteProvincia = exports.setF24OrdinarioSetContribuenteComune = exports.setF24OrdinarioSetContribuenteSesso = exports.setF24OrdinarioSetContribuenteDataDiNascita = exports.setF24OrdinarioSetContribuenteNome = exports.setF24OrdinarioSetContribuenteCognome = exports.setF24OrdinarioSetContribuenteNonCoincidenteAnnoSolare = exports.setF24OrdinarioSetContribuenteCodiceFiscale = exports.setF24OrdinarioResetRiepilogo = exports.setF24OrdinarioResetAction = exports.setF24OrdinarioSetFormSubmitted = void 0;
exports.setF24ElideTotal = exports.setF24ElideCodiceAtto = exports.setF24ElideCodiceUfficio = exports.setF24AcciseRigaImportoDebito = exports.setF24AcciseRigaAnnoRiferimento = exports.setF24AcciseRigaMese = exports.setF24AcciseRigaRateazione = exports.setF24AcciseRigaCodiceIdentificativo = exports.setF24AcciseRigaCodiceTributo = exports.setF24AcciseRigaProvincia = exports.setF24AcciseRigaCodiceEnte = exports.setF24AcciseCodiceTotal = exports.setF24AcciseCodiceAtto = exports.setF24AcciseCodiceUfficio = exports.setF24SemplificatoSetSaldoFinale = exports.setF24SemplificatoSetData = exports.setF24SemplificatoImportoCredito = exports.setF24SemplificatoImportoDebito = exports.setF24SemplificatoDetrazioni = exports.setF24SemplificatoAnno = exports.setF24SemplificatoRate = exports.setF24SemplificatoNumeroImmobiliari = exports.setF24SemplificatoAcconto = exports.setF24SemplificatoSaldo = exports.setF24SemplificatoImmobiliariVariati = exports.setF24SemplificatoRavvedimento = exports.setF24SemplificatoCodiceEnte = exports.setF24SemplificatoCodiceTributo = exports.setF24SemplificatoSezione = exports.setF24OrdinarioSetIdContattoBeneficiario = exports.setF24OrdinarioSetContribuenteAggiungiBeneficiarioWhiteList = exports.setF24OrdinarioSetContribuenteAggiungiBeneficiarioRubrica = exports.setProvenienzaRevocaF24Ordinario = exports.setRiepilogoRevocaF24Ordinario = exports.setF24OrdinarioSetRapportoSelezionato = exports.setF24OrdinarioSetStep = exports.setF24OrdinarioSetSezioneDataESaldoData = exports.setF24OrdinarioSetSezioneAltriEntiMNRigaImportoCredito = exports.setF24OrdinarioSetSezioneAltriEntiMNRigaImportoDebito = exports.setF24OrdinarioSetSezioneAltriEntiMNRigaPeriodoA = exports.setF24OrdinarioSetSezioneAltriEntiMNRigaPeriodoDa = exports.setF24OrdinarioSetSezioneAltriEntiMNRigaCodicePosizione = exports.setF24OrdinarioSetSezioneAltriEntiMNRigaCausaleContributo = exports.setF24OrdinarioSetSezioneAltriEntiMNRigaCodiceSede = exports.setF24OrdinarioSetSezioneAltriEntiMNRigaCodiceEnte = exports.setF24OrdinarioSetSezioneAltriEntiILRigaImportoCredito = exports.setF24OrdinarioSetSezioneAltriEntiILRigaImportoDebito = exports.setF24OrdinarioSetSezioneAltriEntiILRigaCausale = exports.setF24OrdinarioSetSezioneAltriEntiILRigaNumeroDiRiferimento = exports.setF24OrdinarioSetSezioneAltriEntiILRigaCC = void 0;
exports.getCodiciUfficioF24 = exports.getCodiciEnteF24Semplificato = exports.esportaQuietanzaF24PDF = exports.esportaDettaglioF24PDF = exports.delBozzaF24Ordinario = exports.addBozzaF24Ordinario = exports.getBozzeF24Ordinario = exports.autorizzaRevocaF24Ordinario = exports.getInfoRevocaF24Ordinario = exports.autorizzaF24Ordinario = exports.autorizzaF24Semplificato = exports.getInfoDispositivaF24Ordinario = exports.controlloF24Ordinario = exports.getParametriF24 = exports.updateBozzaF24Ordinario = exports.shouldUpdateF24Elide = exports.shouldUpdateF24Accise = exports.shouldUpdateF24Semplificato = exports.shouldUpdateF24Ordinario = exports.getF24OrdinarioFromBozza = exports.setF24OrdinarioRevocaSetStep = exports.setF24SemplificatoSetNumeroIdentificativo = exports.setF24SemplificatoRimuoviMotivo = exports.setF24SemplificatoAggiungiMotivo = exports.setF24OrdinarioSetBozzaSalvata = exports.setF24ElideRigaImportoDebito = exports.setF24ElideRigaAnnoRiferimento = exports.setF24ElideRigaCodiceTributo = exports.setF24ElideRigaElementoId = exports.setF24ElideRigaTipoVeicolo = void 0;
// import { ApiDocumentSessionTokenDownloadGetRequest, ApiDocumentSessionTokenInfoGetRequest, Configuration as ConfigurationF24, DocumentSessionApi, DocumentSessionInfoResponseDto, F24Model, InitDocumentSessionResponseDto } from '@sparkasse/api-f24';
const api_rest_1 = require("@sparkasse/api-rest");
const __1 = require("..");
const general_actions_1 = require("../general/general.actions");
const general_configuration_1 = require("../general/general.configuration");
const general_types_1 = require("../general/general.types");
const helpers_1 = require("../helpers");
const f24_selectors_1 = require("./f24.selectors");
const moment = require("moment");
function generalError(value, showGenericModalError, sendErrorToMatomo, dispositiva, nomeEvento) {
    return async (dispatch) => {
        dispatch((0, general_actions_1.setError)(value, showGenericModalError));
        (!!dispositiva && sendErrorToMatomo) && sendErrorToMatomo(dispositiva, `code_error ${dispositiva.toUpperCase()} ${value.status} / ${value.message} / ${value.timestamp}`, nomeEvento);
    };
}
function setF24OrdinarioSetFormSubmitted(value) {
    return {
        type: __1.EReduxActionTypes.F24_ORDINARIO_SET_FORM_SUBMITTED,
        payload: value
    };
}
exports.setF24OrdinarioSetFormSubmitted = setF24OrdinarioSetFormSubmitted;
function setF24OrdinarioResetAction() {
    return {
        type: __1.EReduxActionTypes.F24_ORDINARIO_RESET
    };
}
exports.setF24OrdinarioResetAction = setF24OrdinarioResetAction;
function setF24OrdinarioResetRiepilogo() {
    return {
        type: __1.EReduxActionTypes.F24_ORDINARIO_RESET_RIEPILOGO
    };
}
exports.setF24OrdinarioResetRiepilogo = setF24OrdinarioResetRiepilogo;
function setF24OrdinarioSetContribuenteCodiceFiscale(value) {
    return {
        type: __1.EReduxActionTypes.F24_ORDINARIO_SET_CONTRIBUENTE_CODICE_FISCALE,
        payload: value
    };
}
exports.setF24OrdinarioSetContribuenteCodiceFiscale = setF24OrdinarioSetContribuenteCodiceFiscale;
function setF24OrdinarioSetContribuenteNonCoincidenteAnnoSolare(value) {
    return {
        type: __1.EReduxActionTypes.F24_ORDINARIO_SET_CONTRIBUENTE_NON_COINCIDENTE_ANNO_SOLARE,
        payload: value
    };
}
exports.setF24OrdinarioSetContribuenteNonCoincidenteAnnoSolare = setF24OrdinarioSetContribuenteNonCoincidenteAnnoSolare;
function setF24OrdinarioSetContribuenteCognome(value) {
    return {
        type: __1.EReduxActionTypes.F24_ORDINARIO_SET_CONTRIBUENTE_COGNOME,
        payload: value
    };
}
exports.setF24OrdinarioSetContribuenteCognome = setF24OrdinarioSetContribuenteCognome;
function setF24OrdinarioSetContribuenteNome(value) {
    return {
        type: __1.EReduxActionTypes.F24_ORDINARIO_SET_CONTRIBUENTE_NOME,
        payload: value
    };
}
exports.setF24OrdinarioSetContribuenteNome = setF24OrdinarioSetContribuenteNome;
function setF24OrdinarioSetContribuenteDataDiNascita(value) {
    return {
        type: __1.EReduxActionTypes.F24_ORDINARIO_SET_CONTRIBUENTE_DATA_NASCITA,
        payload: value
    };
}
exports.setF24OrdinarioSetContribuenteDataDiNascita = setF24OrdinarioSetContribuenteDataDiNascita;
function setF24OrdinarioSetContribuenteSesso(value) {
    return {
        type: __1.EReduxActionTypes.F24_ORDINARIO_SET_CONTRIBUENTE_SESSO,
        payload: value
    };
}
exports.setF24OrdinarioSetContribuenteSesso = setF24OrdinarioSetContribuenteSesso;
function setF24OrdinarioSetContribuenteComune(value) {
    return {
        type: __1.EReduxActionTypes.F24_ORDINARIO_SET_CONTRIBUENTE_COMUNE,
        payload: value
    };
}
exports.setF24OrdinarioSetContribuenteComune = setF24OrdinarioSetContribuenteComune;
function setF24OrdinarioSetContribuenteProvincia(value) {
    return {
        type: __1.EReduxActionTypes.F24_ORDINARIO_SET_CONTRIBUENTE_PROVINCIA,
        payload: value
    };
}
exports.setF24OrdinarioSetContribuenteProvincia = setF24OrdinarioSetContribuenteProvincia;
function setF24OrdinarioSetContribuenteDomicilioFiscaleComune(value) {
    return {
        type: __1.EReduxActionTypes.F24_ORDINARIO_SET_DOMICILIO_FISCALE_COMUNE,
        payload: value
    };
}
exports.setF24OrdinarioSetContribuenteDomicilioFiscaleComune = setF24OrdinarioSetContribuenteDomicilioFiscaleComune;
function setF24OrdinarioSetContribuenteDomicilioFiscaleProvincia(value) {
    return {
        type: __1.EReduxActionTypes.F24_ORDINARIO_SET_DOMICILIO_FISCALE_PROVINCIA,
        payload: value
    };
}
exports.setF24OrdinarioSetContribuenteDomicilioFiscaleProvincia = setF24OrdinarioSetContribuenteDomicilioFiscaleProvincia;
function setF24OrdinarioSetContribuenteDomicilioFiscaleViaECivico(value) {
    return {
        type: __1.EReduxActionTypes.F24_ORDINARIO_SET_DOMICILIO_FISCALE_VIA_E_CIVICO,
        payload: value
    };
}
exports.setF24OrdinarioSetContribuenteDomicilioFiscaleViaECivico = setF24OrdinarioSetContribuenteDomicilioFiscaleViaECivico;
function setF24OrdinarioSetContribuenteCodiceFiscaleCoobligato(value) {
    return {
        type: __1.EReduxActionTypes.F24_ORDINARIO_SET_CODICE_FISCALE_COOBLIGATO,
        payload: value
    };
}
exports.setF24OrdinarioSetContribuenteCodiceFiscaleCoobligato = setF24OrdinarioSetContribuenteCodiceFiscaleCoobligato;
function setF24OrdinarioSetContribuenteCodiceIdentificativoCoobligato(value) {
    return {
        type: __1.EReduxActionTypes.F24_ORDINARIO_SET_CODICE_IDENTIFICATIVO_COOBLIGATO,
        payload: value
    };
}
exports.setF24OrdinarioSetContribuenteCodiceIdentificativoCoobligato = setF24OrdinarioSetContribuenteCodiceIdentificativoCoobligato;
function setF24OrdinarioSetSezioneErarioCodiceAtto(value) {
    return {
        type: __1.EReduxActionTypes.F24_ORDINARIO_SET_ERARIO_CODICE_ATTO,
        payload: value
    };
}
exports.setF24OrdinarioSetSezioneErarioCodiceAtto = setF24OrdinarioSetSezioneErarioCodiceAtto;
function setF24OrdinarioSetSezioneErarioCodiceUfficio(value) {
    return {
        type: __1.EReduxActionTypes.F24_ORDINARIO_SET_ERARIO_CODICE_UFFICIO,
        payload: value
    };
}
exports.setF24OrdinarioSetSezioneErarioCodiceUfficio = setF24OrdinarioSetSezioneErarioCodiceUfficio;
function setF24OrdinarioSetSezioneErarioRigaCodiceTributo(value, riga) {
    return {
        type: __1.EReduxActionTypes.F24_ORDINARIO_SET_ERARIO_RIGA_CODICE_TRIBUTO,
        payload: value,
        riga: riga
    };
}
exports.setF24OrdinarioSetSezioneErarioRigaCodiceTributo = setF24OrdinarioSetSezioneErarioRigaCodiceTributo;
function setF24OrdinarioSetSezioneErarioRigaRateazione(value, riga) {
    return {
        type: __1.EReduxActionTypes.F24_ORDINARIO_SET_ERARIO_RIGA_RATEAZIONE,
        payload: value,
        riga: riga
    };
}
exports.setF24OrdinarioSetSezioneErarioRigaRateazione = setF24OrdinarioSetSezioneErarioRigaRateazione;
function setF24OrdinarioSetSezioneErarioRigaAnnoDiRiferimento(value, riga) {
    return {
        type: __1.EReduxActionTypes.F24_ORDINARIO_SET_ERARIO_RIGA_ANNO_RIFERIMENTO,
        payload: value,
        riga: riga
    };
}
exports.setF24OrdinarioSetSezioneErarioRigaAnnoDiRiferimento = setF24OrdinarioSetSezioneErarioRigaAnnoDiRiferimento;
function setF24OrdinarioSetSezioneErarioRigaImportoDebito(value, riga) {
    return {
        type: __1.EReduxActionTypes.F24_ORDINARIO_SET_ERARIO_RIGA_DEBITO,
        payload: value,
        riga: riga
    };
}
exports.setF24OrdinarioSetSezioneErarioRigaImportoDebito = setF24OrdinarioSetSezioneErarioRigaImportoDebito;
function setF24OrdinarioSetSezioneErarioRigaImportoCredito(value, riga) {
    return {
        type: __1.EReduxActionTypes.F24_ORDINARIO_SET_ERARIO_RIGA_CREDITO,
        payload: value,
        riga: riga
    };
}
exports.setF24OrdinarioSetSezioneErarioRigaImportoCredito = setF24OrdinarioSetSezioneErarioRigaImportoCredito;
function setF24OrdinarioSetSezioneInpsRigaCodiceSede(value, riga) {
    return {
        type: __1.EReduxActionTypes.F24_ORDINARIO_SET_INPS_RIGA_CODICE_SEDE,
        payload: value,
        riga: riga
    };
}
exports.setF24OrdinarioSetSezioneInpsRigaCodiceSede = setF24OrdinarioSetSezioneInpsRigaCodiceSede;
function setF24OrdinarioSetSezioneInpsRigaCausaleContributo(value, riga) {
    return {
        type: __1.EReduxActionTypes.F24_ORDINARIO_SET_INPS_RIGA_CAUSALE_CONTRIBUTO,
        payload: value,
        riga: riga
    };
}
exports.setF24OrdinarioSetSezioneInpsRigaCausaleContributo = setF24OrdinarioSetSezioneInpsRigaCausaleContributo;
function setF24OrdinarioSetSezioneInpsRigaMatricolaINPS(value, riga) {
    return {
        type: __1.EReduxActionTypes.F24_ORDINARIO_SET_INPS_RIGA_MATRICOLA,
        payload: value,
        riga: riga
    };
}
exports.setF24OrdinarioSetSezioneInpsRigaMatricolaINPS = setF24OrdinarioSetSezioneInpsRigaMatricolaINPS;
function setF24OrdinarioSetSezioneInpsRigaPeriodoDa(value, riga) {
    return {
        type: __1.EReduxActionTypes.F24_ORDINARIO_SET_INPS_RIGA_PERIODO_DA,
        payload: value,
        riga: riga
    };
}
exports.setF24OrdinarioSetSezioneInpsRigaPeriodoDa = setF24OrdinarioSetSezioneInpsRigaPeriodoDa;
function setF24OrdinarioSetSezioneInpsRigaPeriodoA(value, riga) {
    return {
        type: __1.EReduxActionTypes.F24_ORDINARIO_SET_INPS_RIGA_PERIODO_A,
        payload: value,
        riga: riga
    };
}
exports.setF24OrdinarioSetSezioneInpsRigaPeriodoA = setF24OrdinarioSetSezioneInpsRigaPeriodoA;
function setF24OrdinarioSetSezioneInpsRigaImportoDebito(value, riga) {
    return {
        type: __1.EReduxActionTypes.F24_ORDINARIO_SET_INPS_RIGA_DEBITO,
        payload: value,
        riga: riga
    };
}
exports.setF24OrdinarioSetSezioneInpsRigaImportoDebito = setF24OrdinarioSetSezioneInpsRigaImportoDebito;
function setF24OrdinarioSetSezioneInpsRigaImportoCredito(value, riga) {
    return {
        type: __1.EReduxActionTypes.F24_ORDINARIO_SET_INPS_RIGA_CREDITO,
        payload: value,
        riga: riga
    };
}
exports.setF24OrdinarioSetSezioneInpsRigaImportoCredito = setF24OrdinarioSetSezioneInpsRigaImportoCredito;
function setF24OrdinarioSetSezioneRegioniRigaCodiceRegione(value, riga) {
    return {
        type: __1.EReduxActionTypes.F24_ORDINARIO_SET_REGIONE_RIGA_CODICE_REGIONE,
        payload: value,
        riga: riga
    };
}
exports.setF24OrdinarioSetSezioneRegioniRigaCodiceRegione = setF24OrdinarioSetSezioneRegioniRigaCodiceRegione;
function setF24OrdinarioSetSezioneRegioniRigaCodiceTributo(value, riga) {
    return {
        type: __1.EReduxActionTypes.F24_ORDINARIO_SET_REGIONE_RIGA_CODICE_TRIBUTO,
        payload: value,
        riga: riga
    };
}
exports.setF24OrdinarioSetSezioneRegioniRigaCodiceTributo = setF24OrdinarioSetSezioneRegioniRigaCodiceTributo;
function setF24OrdinarioSetSezioneRegioniRigaRateazione(value, riga) {
    return {
        type: __1.EReduxActionTypes.F24_ORDINARIO_SET_REGIONE_RIGA_RATEAZIONE,
        payload: value,
        riga: riga
    };
}
exports.setF24OrdinarioSetSezioneRegioniRigaRateazione = setF24OrdinarioSetSezioneRegioniRigaRateazione;
function setF24OrdinarioSetSezioneRegioniRigaAnnoRiferimento(value, riga) {
    return {
        type: __1.EReduxActionTypes.F24_ORDINARIO_SET_REGIONE_RIGA_ANNO_RIFERIMENTO,
        payload: value,
        riga: riga
    };
}
exports.setF24OrdinarioSetSezioneRegioniRigaAnnoRiferimento = setF24OrdinarioSetSezioneRegioniRigaAnnoRiferimento;
function setF24OrdinarioSetSezioneRegioniRigaImportoDebito(value, riga) {
    return {
        type: __1.EReduxActionTypes.F24_ORDINARIO_SET_REGIONE_RIGA_DEBITO,
        payload: value,
        riga: riga
    };
}
exports.setF24OrdinarioSetSezioneRegioniRigaImportoDebito = setF24OrdinarioSetSezioneRegioniRigaImportoDebito;
function setF24OrdinarioSetSezioneRegioniRigaImportoCredito(value, riga) {
    return {
        type: __1.EReduxActionTypes.F24_ORDINARIO_SET_REGIONE_RIGA_CREDITO,
        payload: value,
        riga: riga
    };
}
exports.setF24OrdinarioSetSezioneRegioniRigaImportoCredito = setF24OrdinarioSetSezioneRegioniRigaImportoCredito;
function setF24OrdinarioSetSezioneImuDetrazione(value) {
    return {
        type: __1.EReduxActionTypes.F24_ORDINARIO_SET_IMU_DETRAZIONE,
        payload: value
    };
}
exports.setF24OrdinarioSetSezioneImuDetrazione = setF24OrdinarioSetSezioneImuDetrazione;
function setF24OrdinarioSetSezioneImuRigaCodiceRegione(value, riga) {
    return {
        type: __1.EReduxActionTypes.F24_ORDINARIO_SET_IMU_RIGA_CODICE_REGIONE,
        payload: value,
        riga: riga
    };
}
exports.setF24OrdinarioSetSezioneImuRigaCodiceRegione = setF24OrdinarioSetSezioneImuRigaCodiceRegione;
function setF24OrdinarioSetSezioneImuRigaR(value, riga) {
    return {
        type: __1.EReduxActionTypes.F24_ORDINARIO_SET_IMU_RIGA_R,
        payload: value,
        riga: riga
    };
}
exports.setF24OrdinarioSetSezioneImuRigaR = setF24OrdinarioSetSezioneImuRigaR;
function setF24OrdinarioSetSezioneImuRigaIV(value, riga) {
    return {
        type: __1.EReduxActionTypes.F24_ORDINARIO_SET_IMU_RIGA_IV,
        payload: value,
        riga: riga
    };
}
exports.setF24OrdinarioSetSezioneImuRigaIV = setF24OrdinarioSetSezioneImuRigaIV;
function setF24OrdinarioSetSezioneImuRigaA(value, riga) {
    return {
        type: __1.EReduxActionTypes.F24_ORDINARIO_SET_IMU_RIGA_A,
        payload: value,
        riga: riga
    };
}
exports.setF24OrdinarioSetSezioneImuRigaA = setF24OrdinarioSetSezioneImuRigaA;
function setF24OrdinarioSetSezioneImuRigaS(value, riga) {
    return {
        type: __1.EReduxActionTypes.F24_ORDINARIO_SET_IMU_RIGA_S,
        payload: value,
        riga: riga
    };
}
exports.setF24OrdinarioSetSezioneImuRigaS = setF24OrdinarioSetSezioneImuRigaS;
function setF24OrdinarioSetSezioneImuRigaNI(value, riga) {
    return {
        type: __1.EReduxActionTypes.F24_ORDINARIO_SET_IMU_RIGA_NI,
        payload: value,
        riga: riga
    };
}
exports.setF24OrdinarioSetSezioneImuRigaNI = setF24OrdinarioSetSezioneImuRigaNI;
function setF24OrdinarioSetSezioneImuRigaCodiceTributo(value, riga) {
    return {
        type: __1.EReduxActionTypes.F24_ORDINARIO_SET_IMU_RIGA_CODICE_TRIBUTO,
        payload: value,
        riga: riga
    };
}
exports.setF24OrdinarioSetSezioneImuRigaCodiceTributo = setF24OrdinarioSetSezioneImuRigaCodiceTributo;
function setF24OrdinarioSetSezioneImuRigaRateazione(value, riga) {
    return {
        type: __1.EReduxActionTypes.F24_ORDINARIO_SET_IMU_RIGA_RATEAZIONE,
        payload: value,
        riga: riga
    };
}
exports.setF24OrdinarioSetSezioneImuRigaRateazione = setF24OrdinarioSetSezioneImuRigaRateazione;
function setF24OrdinarioSetSezioneImuRigaAnnoRiferimento(value, riga) {
    return {
        type: __1.EReduxActionTypes.F24_ORDINARIO_SET_IMU_RIGA_ANNO_RIFERIMENTO,
        payload: value,
        riga: riga
    };
}
exports.setF24OrdinarioSetSezioneImuRigaAnnoRiferimento = setF24OrdinarioSetSezioneImuRigaAnnoRiferimento;
function setF24OrdinarioSetSezioneImuRigaImportoDebito(value, riga) {
    return {
        type: __1.EReduxActionTypes.F24_ORDINARIO_SET_IMU_RIGA_DEBITO,
        payload: value,
        riga: riga
    };
}
exports.setF24OrdinarioSetSezioneImuRigaImportoDebito = setF24OrdinarioSetSezioneImuRigaImportoDebito;
function setF24OrdinarioSetSezioneImuRigaImportoCredito(value, riga) {
    return {
        type: __1.EReduxActionTypes.F24_ORDINARIO_SET_IMU_RIGA_CREDITO,
        payload: value,
        riga: riga
    };
}
exports.setF24OrdinarioSetSezioneImuRigaImportoCredito = setF24OrdinarioSetSezioneImuRigaImportoCredito;
function setF24OrdinarioSetSezioneAltriEntiILRigaCodiceSede(value, riga) {
    return {
        type: __1.EReduxActionTypes.F24_ORDINARIO_SET_ALTRI_ENTI_IL_RIGA_CODICE_SEDE,
        payload: value,
        riga: riga
    };
}
exports.setF24OrdinarioSetSezioneAltriEntiILRigaCodiceSede = setF24OrdinarioSetSezioneAltriEntiILRigaCodiceSede;
function setF24OrdinarioSetSezioneAltriEntiILRigaCodiceDitta(value, riga) {
    return {
        type: __1.EReduxActionTypes.F24_ORDINARIO_SET_ALTRI_ENTI_IL_RIGA_CODICE_DITTA,
        payload: value,
        riga: riga
    };
}
exports.setF24OrdinarioSetSezioneAltriEntiILRigaCodiceDitta = setF24OrdinarioSetSezioneAltriEntiILRigaCodiceDitta;
function setF24OrdinarioSetSezioneAltriEntiILRigaCC(value, riga) {
    return {
        type: __1.EReduxActionTypes.F24_ORDINARIO_SET_ALTRI_ENTI_IL_RIGA_CC,
        payload: value,
        riga: riga
    };
}
exports.setF24OrdinarioSetSezioneAltriEntiILRigaCC = setF24OrdinarioSetSezioneAltriEntiILRigaCC;
function setF24OrdinarioSetSezioneAltriEntiILRigaNumeroDiRiferimento(value, riga) {
    return {
        type: __1.EReduxActionTypes.F24_ORDINARIO_SET_ALTRI_ENTI_IL_RIGA_NUMERO_RIFERIMENTO,
        payload: value,
        riga: riga
    };
}
exports.setF24OrdinarioSetSezioneAltriEntiILRigaNumeroDiRiferimento = setF24OrdinarioSetSezioneAltriEntiILRigaNumeroDiRiferimento;
function setF24OrdinarioSetSezioneAltriEntiILRigaCausale(value, riga) {
    return {
        type: __1.EReduxActionTypes.F24_ORDINARIO_SET_ALTRI_ENTI_IL_RIGA_CAUSALE,
        payload: value,
        riga: riga
    };
}
exports.setF24OrdinarioSetSezioneAltriEntiILRigaCausale = setF24OrdinarioSetSezioneAltriEntiILRigaCausale;
function setF24OrdinarioSetSezioneAltriEntiILRigaImportoDebito(value, riga) {
    return {
        type: __1.EReduxActionTypes.F24_ORDINARIO_SET_ALTRI_ENTI_IL_RIGA_DEBITO,
        payload: value,
        riga: riga
    };
}
exports.setF24OrdinarioSetSezioneAltriEntiILRigaImportoDebito = setF24OrdinarioSetSezioneAltriEntiILRigaImportoDebito;
function setF24OrdinarioSetSezioneAltriEntiILRigaImportoCredito(value, riga) {
    return {
        type: __1.EReduxActionTypes.F24_ORDINARIO_SET_ALTRI_ENTI_IL_RIGA_CREDITO,
        payload: value,
        riga: riga
    };
}
exports.setF24OrdinarioSetSezioneAltriEntiILRigaImportoCredito = setF24OrdinarioSetSezioneAltriEntiILRigaImportoCredito;
function setF24OrdinarioSetSezioneAltriEntiMNRigaCodiceEnte(value, riga) {
    return {
        type: __1.EReduxActionTypes.F24_ORDINARIO_SET_ALTRI_ENTI_MN_RIGA_CODICE_ENTE,
        payload: value,
        riga: riga
    };
}
exports.setF24OrdinarioSetSezioneAltriEntiMNRigaCodiceEnte = setF24OrdinarioSetSezioneAltriEntiMNRigaCodiceEnte;
function setF24OrdinarioSetSezioneAltriEntiMNRigaCodiceSede(value, riga) {
    return {
        type: __1.EReduxActionTypes.F24_ORDINARIO_SET_ALTRI_ENTI_MN_RIGA_CODICE_SEDE,
        payload: value,
        riga: riga
    };
}
exports.setF24OrdinarioSetSezioneAltriEntiMNRigaCodiceSede = setF24OrdinarioSetSezioneAltriEntiMNRigaCodiceSede;
function setF24OrdinarioSetSezioneAltriEntiMNRigaCausaleContributo(value, riga) {
    return {
        type: __1.EReduxActionTypes.F24_ORDINARIO_SET_ALTRI_ENTI_MN_RIGA_CAUSALE_CONTRIBUTO,
        payload: value,
        riga: riga
    };
}
exports.setF24OrdinarioSetSezioneAltriEntiMNRigaCausaleContributo = setF24OrdinarioSetSezioneAltriEntiMNRigaCausaleContributo;
function setF24OrdinarioSetSezioneAltriEntiMNRigaCodicePosizione(value, riga) {
    return {
        type: __1.EReduxActionTypes.F24_ORDINARIO_SET_ALTRI_ENTI_MN_RIGA_CODICE_POSIZIONE,
        payload: value,
        riga: riga
    };
}
exports.setF24OrdinarioSetSezioneAltriEntiMNRigaCodicePosizione = setF24OrdinarioSetSezioneAltriEntiMNRigaCodicePosizione;
function setF24OrdinarioSetSezioneAltriEntiMNRigaPeriodoDa(value, riga) {
    return {
        type: __1.EReduxActionTypes.F24_ORDINARIO_SET_ALTRI_ENTI_MN_RIGA_PERIODO_DA,
        payload: value,
        riga: riga
    };
}
exports.setF24OrdinarioSetSezioneAltriEntiMNRigaPeriodoDa = setF24OrdinarioSetSezioneAltriEntiMNRigaPeriodoDa;
function setF24OrdinarioSetSezioneAltriEntiMNRigaPeriodoA(value, riga) {
    return {
        type: __1.EReduxActionTypes.F24_ORDINARIO_SET_ALTRI_ENTI_MN_RIGA_PERIODO_A,
        payload: value,
        riga: riga
    };
}
exports.setF24OrdinarioSetSezioneAltriEntiMNRigaPeriodoA = setF24OrdinarioSetSezioneAltriEntiMNRigaPeriodoA;
function setF24OrdinarioSetSezioneAltriEntiMNRigaImportoDebito(value, riga) {
    return {
        type: __1.EReduxActionTypes.F24_ORDINARIO_SET_ALTRI_ENTI_MN_RIGA_DEBITO,
        payload: value,
        riga: riga
    };
}
exports.setF24OrdinarioSetSezioneAltriEntiMNRigaImportoDebito = setF24OrdinarioSetSezioneAltriEntiMNRigaImportoDebito;
function setF24OrdinarioSetSezioneAltriEntiMNRigaImportoCredito(value, riga) {
    return {
        type: __1.EReduxActionTypes.F24_ORDINARIO_SET_ALTRI_ENTI_MN_RIGA_CREDITO,
        payload: value,
        riga: riga
    };
}
exports.setF24OrdinarioSetSezioneAltriEntiMNRigaImportoCredito = setF24OrdinarioSetSezioneAltriEntiMNRigaImportoCredito;
function setF24OrdinarioSetSezioneDataESaldoData(value) {
    return {
        type: __1.EReduxActionTypes.F24_ORDINARIO_SET_DATA,
        payload: value
    };
}
exports.setF24OrdinarioSetSezioneDataESaldoData = setF24OrdinarioSetSezioneDataESaldoData;
function setF24OrdinarioSetStep(step) {
    return {
        type: __1.EReduxActionTypes.F24_ORDINARIO_SET_STEP,
        payload: step
    };
}
exports.setF24OrdinarioSetStep = setF24OrdinarioSetStep;
function setF24OrdinarioSetRapportoSelezionato(rapportoSelezionato) {
    return {
        type: __1.EReduxActionTypes.F24_ORDINARIO_SET_RAPPORTO_SELEZIONATO,
        payload: rapportoSelezionato
    };
}
exports.setF24OrdinarioSetRapportoSelezionato = setF24OrdinarioSetRapportoSelezionato;
function setRiepilogoRevocaF24Ordinario(riepilogo) {
    return {
        type: __1.EReduxActionTypes.F24_ORDINARIO_SET_RIEPILOGO_REVOCA,
        payload: riepilogo
    };
}
exports.setRiepilogoRevocaF24Ordinario = setRiepilogoRevocaF24Ordinario;
function setProvenienzaRevocaF24Ordinario(provenienza) {
    return {
        type: __1.EReduxActionTypes.F24_ORDINARIO_SET_PROVENIENZA,
        payload: provenienza
    };
}
exports.setProvenienzaRevocaF24Ordinario = setProvenienzaRevocaF24Ordinario;
function setF24OrdinarioSetContribuenteAggiungiBeneficiarioRubrica(value) {
    return {
        type: __1.EReduxActionTypes.F24_ORDINARIO_SET_CONTRIBUENTE_AGGIUNGI_BENEFICIARIO_RUBRICA,
        payload: value
    };
}
exports.setF24OrdinarioSetContribuenteAggiungiBeneficiarioRubrica = setF24OrdinarioSetContribuenteAggiungiBeneficiarioRubrica;
function setF24OrdinarioSetContribuenteAggiungiBeneficiarioWhiteList(value) {
    return {
        type: __1.EReduxActionTypes.F24_ORDINARIO_SET_CONTRIBUENTE_AGGIUNGI_BENEFICIARIO_WHITE_LIST,
        payload: value
    };
}
exports.setF24OrdinarioSetContribuenteAggiungiBeneficiarioWhiteList = setF24OrdinarioSetContribuenteAggiungiBeneficiarioWhiteList;
function setF24OrdinarioSetIdContattoBeneficiario(id) {
    return {
        type: __1.EReduxActionTypes.F24_ORDINARIO_SET_ID_CONTATTO_BENEFICIARIO,
        payload: id
    };
}
exports.setF24OrdinarioSetIdContattoBeneficiario = setF24OrdinarioSetIdContattoBeneficiario;
function setF24SemplificatoSezione(value, riga) {
    return {
        type: __1.EReduxActionTypes.F24_SEMPLIFICATO_SET_SEZIONE,
        payload: value,
        riga: riga
    };
}
exports.setF24SemplificatoSezione = setF24SemplificatoSezione;
function setF24SemplificatoCodiceTributo(value, riga) {
    return {
        type: __1.EReduxActionTypes.F24_SEMPLIFICATO_SET_CODICE_TRIBUTO,
        payload: value,
        riga: riga
    };
}
exports.setF24SemplificatoCodiceTributo = setF24SemplificatoCodiceTributo;
function setF24SemplificatoCodiceEnte(value, riga) {
    return {
        type: __1.EReduxActionTypes.F24_SEMPLIFICATO_SET_CODICE_ENTE,
        payload: value,
        riga: riga
    };
}
exports.setF24SemplificatoCodiceEnte = setF24SemplificatoCodiceEnte;
function setF24SemplificatoRavvedimento(value, riga) {
    return {
        type: __1.EReduxActionTypes.F24_SEMPLIFICATO_SET_RAVVEDIMENTO,
        payload: value,
        riga: riga
    };
}
exports.setF24SemplificatoRavvedimento = setF24SemplificatoRavvedimento;
function setF24SemplificatoImmobiliariVariati(value, riga) {
    return {
        type: __1.EReduxActionTypes.F24_SEMPLIFICATO_SET_IMMOBILIARI_VARIATI,
        payload: value,
        riga: riga
    };
}
exports.setF24SemplificatoImmobiliariVariati = setF24SemplificatoImmobiliariVariati;
function setF24SemplificatoSaldo(value, riga) {
    return {
        type: __1.EReduxActionTypes.F24_SEMPLIFICATO_SET_SALDO,
        payload: value,
        riga: riga
    };
}
exports.setF24SemplificatoSaldo = setF24SemplificatoSaldo;
function setF24SemplificatoAcconto(value, riga) {
    return {
        type: __1.EReduxActionTypes.F24_SEMPLIFICATO_SET_ACCONTO,
        payload: value,
        riga: riga
    };
}
exports.setF24SemplificatoAcconto = setF24SemplificatoAcconto;
function setF24SemplificatoNumeroImmobiliari(value, riga) {
    return {
        type: __1.EReduxActionTypes.F24_SEMPLIFICATO_SET_NUMERO_IMMOBILIARI,
        payload: value,
        riga: riga
    };
}
exports.setF24SemplificatoNumeroImmobiliari = setF24SemplificatoNumeroImmobiliari;
function setF24SemplificatoRate(value, riga) {
    return {
        type: __1.EReduxActionTypes.F24_SEMPLIFICATO_SET_RATE,
        payload: value,
        riga: riga
    };
}
exports.setF24SemplificatoRate = setF24SemplificatoRate;
function setF24SemplificatoAnno(value, riga) {
    return {
        type: __1.EReduxActionTypes.F24_SEMPLIFICATO_SET_ANNO,
        payload: value,
        riga: riga
    };
}
exports.setF24SemplificatoAnno = setF24SemplificatoAnno;
function setF24SemplificatoDetrazioni(value, riga) {
    return {
        type: __1.EReduxActionTypes.F24_SEMPLIFICATO_SET_DETRAZIONI,
        payload: value,
        riga: riga
    };
}
exports.setF24SemplificatoDetrazioni = setF24SemplificatoDetrazioni;
function setF24SemplificatoImportoDebito(value, riga) {
    return {
        type: __1.EReduxActionTypes.F24_SEMPLIFICATO_SET_IMPORTO_DEBITO,
        payload: value,
        riga: riga
    };
}
exports.setF24SemplificatoImportoDebito = setF24SemplificatoImportoDebito;
function setF24SemplificatoImportoCredito(value, riga) {
    return {
        type: __1.EReduxActionTypes.F24_SEMPLIFICATO_SET_IMPORTO_CREDITO,
        payload: value,
        riga: riga
    };
}
exports.setF24SemplificatoImportoCredito = setF24SemplificatoImportoCredito;
function setF24SemplificatoSetData(value) {
    return {
        type: __1.EReduxActionTypes.F24_SEMPLIFICATO_SET_DATA,
        payload: value
    };
}
exports.setF24SemplificatoSetData = setF24SemplificatoSetData;
function setF24SemplificatoSetSaldoFinale(value) {
    return {
        type: __1.EReduxActionTypes.F24_SEMPLIFICATO_SET_SALDO_EURO,
        payload: value
    };
}
exports.setF24SemplificatoSetSaldoFinale = setF24SemplificatoSetSaldoFinale;
function setF24AcciseCodiceUfficio(value) {
    return {
        type: __1.EReduxActionTypes.F24_ACCISE_SET_CODICE_UFFICIO,
        payload: value
    };
}
exports.setF24AcciseCodiceUfficio = setF24AcciseCodiceUfficio;
function setF24AcciseCodiceAtto(value) {
    return {
        type: __1.EReduxActionTypes.F24_ACCISE_SET_CODICE_ATTO,
        payload: value
    };
}
exports.setF24AcciseCodiceAtto = setF24AcciseCodiceAtto;
function setF24AcciseCodiceTotal(value) {
    return {
        type: __1.EReduxActionTypes.F24_ACCISE_SET_TOTAL,
        payload: value
    };
}
exports.setF24AcciseCodiceTotal = setF24AcciseCodiceTotal;
function setF24AcciseRigaCodiceEnte(value, riga) {
    return {
        type: __1.EReduxActionTypes.F24_ACCISE_SET_RIGA_CODICE_ENTE,
        payload: value,
        riga: riga
    };
}
exports.setF24AcciseRigaCodiceEnte = setF24AcciseRigaCodiceEnte;
function setF24AcciseRigaProvincia(value, riga) {
    return {
        type: __1.EReduxActionTypes.F24_ACCISE_SET_RIGA_PROVINCIA,
        payload: value,
        riga: riga
    };
}
exports.setF24AcciseRigaProvincia = setF24AcciseRigaProvincia;
function setF24AcciseRigaCodiceTributo(value, riga) {
    return {
        type: __1.EReduxActionTypes.F24_ACCISE_SET_RIGA_CODICE_TRIBUTO,
        payload: value,
        riga: riga
    };
}
exports.setF24AcciseRigaCodiceTributo = setF24AcciseRigaCodiceTributo;
function setF24AcciseRigaCodiceIdentificativo(value, riga) {
    return {
        type: __1.EReduxActionTypes.F24_ACCISE_SET_RIGA_CODICE_IDENTIFICATIVO,
        payload: value,
        riga: riga
    };
}
exports.setF24AcciseRigaCodiceIdentificativo = setF24AcciseRigaCodiceIdentificativo;
function setF24AcciseRigaRateazione(value, riga) {
    return {
        type: __1.EReduxActionTypes.F24_ACCISE_SET_RIGA_RATEAZIONE,
        payload: value,
        riga: riga
    };
}
exports.setF24AcciseRigaRateazione = setF24AcciseRigaRateazione;
function setF24AcciseRigaMese(value, riga) {
    return {
        type: __1.EReduxActionTypes.F24_ACCISE_SET_RIGA_MESE,
        payload: value,
        riga: riga
    };
}
exports.setF24AcciseRigaMese = setF24AcciseRigaMese;
function setF24AcciseRigaAnnoRiferimento(value, riga) {
    return {
        type: __1.EReduxActionTypes.F24_ACCISE_SET_RIGA_ANNO_RIFERIMENTO,
        payload: value,
        riga: riga
    };
}
exports.setF24AcciseRigaAnnoRiferimento = setF24AcciseRigaAnnoRiferimento;
function setF24AcciseRigaImportoDebito(value, riga) {
    return {
        type: __1.EReduxActionTypes.F24_ACCISE_SET_RIGA_IMPORTO_DEBITO,
        payload: value,
        riga: riga
    };
}
exports.setF24AcciseRigaImportoDebito = setF24AcciseRigaImportoDebito;
function setF24ElideCodiceUfficio(value) {
    return {
        type: __1.EReduxActionTypes.F24_ELIDE_SET_CODICE_UFFICIO,
        payload: value
    };
}
exports.setF24ElideCodiceUfficio = setF24ElideCodiceUfficio;
function setF24ElideCodiceAtto(value) {
    return {
        type: __1.EReduxActionTypes.F24_ELIDE_SET_CODICE_ATTO,
        payload: value
    };
}
exports.setF24ElideCodiceAtto = setF24ElideCodiceAtto;
function setF24ElideTotal(value) {
    return {
        type: __1.EReduxActionTypes.F24_ELIDE_SET_TOTAL,
        payload: value
    };
}
exports.setF24ElideTotal = setF24ElideTotal;
function setF24ElideRigaTipoVeicolo(value, riga) {
    return {
        type: __1.EReduxActionTypes.F24_ELIDE_SET_RIGA_TIPO_VEICOLO,
        payload: value,
        riga: riga
    };
}
exports.setF24ElideRigaTipoVeicolo = setF24ElideRigaTipoVeicolo;
function setF24ElideRigaElementoId(value, riga) {
    return {
        type: __1.EReduxActionTypes.F24_ELIDE_SET_RIGA_ELEMENTO_ID,
        payload: value,
        riga: riga
    };
}
exports.setF24ElideRigaElementoId = setF24ElideRigaElementoId;
function setF24ElideRigaCodiceTributo(value, riga) {
    return {
        type: __1.EReduxActionTypes.F24_ELIDE_SET_RIGA_CODICE_TRIBUTO,
        payload: value,
        riga: riga
    };
}
exports.setF24ElideRigaCodiceTributo = setF24ElideRigaCodiceTributo;
function setF24ElideRigaAnnoRiferimento(value, riga) {
    return {
        type: __1.EReduxActionTypes.F24_ELIDE_SET_RIGA_ANNO_RIFERIMENTO,
        payload: value,
        riga: riga
    };
}
exports.setF24ElideRigaAnnoRiferimento = setF24ElideRigaAnnoRiferimento;
function setF24ElideRigaImportoDebito(value, riga) {
    return {
        type: __1.EReduxActionTypes.F24_ELIDE_SET_RIGA_IMPORTO_DEBITO,
        payload: value,
        riga: riga
    };
}
exports.setF24ElideRigaImportoDebito = setF24ElideRigaImportoDebito;
function setF24OrdinarioSetBozzaSalvata(value) {
    return {
        type: __1.EReduxActionTypes.F24_SET_BOZZA_SALVATA,
        payload: value
    };
}
exports.setF24OrdinarioSetBozzaSalvata = setF24OrdinarioSetBozzaSalvata;
function setF24SemplificatoAggiungiMotivo() {
    return {
        type: __1.EReduxActionTypes.F24_SEMPLIFICATO_AGGIUNGI_MOTIVO
    };
}
exports.setF24SemplificatoAggiungiMotivo = setF24SemplificatoAggiungiMotivo;
function setF24SemplificatoRimuoviMotivo(i) {
    return {
        type: __1.EReduxActionTypes.F24_SEMPLIFICATO_RIMUOVI_MOTIVO,
        payload: i
    };
}
exports.setF24SemplificatoRimuoviMotivo = setF24SemplificatoRimuoviMotivo;
function setF24SemplificatoSetNumeroIdentificativo(txt) {
    return {
        type: __1.EReduxActionTypes.F24_SEMPLIFICATO_SET_NUMERO_IDENTIFICATIVO,
        payload: txt
    };
}
exports.setF24SemplificatoSetNumeroIdentificativo = setF24SemplificatoSetNumeroIdentificativo;
function resetMotiviMobile() {
    return {
        type: __1.EReduxActionTypes.F24_SEMPLIFICATO_RESET_MOTIVI_MOBILE
    };
}
function setF24OrdinarioRevocaSetStepAction(i) {
    return {
        type: __1.EReduxActionTypes.F24_ORDINARIO_STEP_REVOCA,
        payload: i
    };
}
const setF24OrdinarioRevocaSetStep = (i) => async (dispatch, _, extraArguments) => {
    dispatch(setF24OrdinarioRevocaSetStepAction(i));
    if (extraArguments.platform == 'mobile') {
        dispatch((0, general_actions_1.setBottomTabBarVisible)(i != 1));
    }
};
exports.setF24OrdinarioRevocaSetStep = setF24OrdinarioRevocaSetStep;
function getF24OrdinarioFromBozzaFunction(payload, noBozza = false, platform) {
    return {
        type: __1.EReduxActionTypes.F24_ORDINARIO_GET_F24_FROM_BOZZA,
        payload,
        noBozza,
        platform
    };
}
// export function getF24FromScanner(payload: F24Model): IF24GetF24FromScannerAction {
//   return {
//     type: EReduxActionTypes.F24_GET_F24_FROM_SCANNER,
//     payload
//   };
// };
const getF24OrdinarioFromBozza = (payload, noBozza = false) => async (dispatch, getState, extraArguments) => {
    dispatch(getF24OrdinarioFromBozzaFunction(payload, noBozza, extraArguments.platform));
};
exports.getF24OrdinarioFromBozza = getF24OrdinarioFromBozza;
const shouldUpdateF24Ordinario = () => async (dispatch, getState, extraArguments) => {
    var _a;
    const state = getState().f24;
    const f24 = (0, f24_selectors_1.buildF24Ordinario)(state);
    if ((0, f24_selectors_1.checkUpdateBozzaOrdinario)(state)) {
        dispatch((0, exports.updateBozzaF24Ordinario)(f24, ((_a = state.currentBozza) === null || _a === void 0 ? void 0 : _a.id) || 0));
    }
    else {
        dispatch((0, exports.addBozzaF24Ordinario)(f24));
    }
    dispatch(setF24OrdinarioSetBozzaSalvata(true));
};
exports.shouldUpdateF24Ordinario = shouldUpdateF24Ordinario;
const shouldUpdateF24Semplificato = () => async (dispatch, getState, extraArguments) => {
    var _a;
    const state = getState().f24;
    const f24Semplificato = (0, f24_selectors_1.buildF24Semplificato)(state);
    if ((0, f24_selectors_1.checkUpdateBozzaSemplificato)(state)) {
        dispatch((0, exports.updateBozzaF24Ordinario)(f24Semplificato, ((_a = state.currentBozza) === null || _a === void 0 ? void 0 : _a.id) || 0));
    }
    else {
        dispatch((0, exports.addBozzaF24Ordinario)(f24Semplificato));
    }
    dispatch(setF24OrdinarioSetBozzaSalvata(true));
};
exports.shouldUpdateF24Semplificato = shouldUpdateF24Semplificato;
const shouldUpdateF24Accise = () => async (dispatch, getState, extraArguments) => {
    var _a;
    const state = getState().f24;
    const f24Accise = (0, f24_selectors_1.buildF24Accise)(state);
    if ((0, f24_selectors_1.checkUpdateBozzaAccise)(state)) {
        dispatch((0, exports.updateBozzaF24Ordinario)(f24Accise, ((_a = state.currentBozza) === null || _a === void 0 ? void 0 : _a.id) || 0));
    }
    else {
        dispatch((0, exports.addBozzaF24Ordinario)(f24Accise));
    }
    dispatch(setF24OrdinarioSetBozzaSalvata(true));
};
exports.shouldUpdateF24Accise = shouldUpdateF24Accise;
const shouldUpdateF24Elide = () => async (dispatch, getState, extraArguments) => {
    var _a;
    const state = getState().f24;
    const f24Elide = (0, f24_selectors_1.buildF24Elide)(state);
    if ((0, f24_selectors_1.checkUpdateBozzaElide)(state)) {
        dispatch((0, exports.updateBozzaF24Ordinario)(f24Elide, ((_a = state.currentBozza) === null || _a === void 0 ? void 0 : _a.id) || 0));
    }
    else {
        dispatch((0, exports.addBozzaF24Ordinario)(f24Elide));
    }
    dispatch(setF24OrdinarioSetBozzaSalvata(true));
};
exports.shouldUpdateF24Elide = shouldUpdateF24Elide;
function updateBozzaF24OrdinarioStart() {
    return {
        type: __1.EReduxActionTypes.F24_UPDATE_BOZZA_START
    };
}
function updateBozzaF24OrdinarioSuccess(payload) {
    return {
        type: __1.EReduxActionTypes.F24_UPDATE_BOZZA_SUCCESS,
        payload
    };
}
const updateBozzaF24Ordinario = (parameter, id) => async (dispatch, _, extraArguments) => {
    dispatch((0, general_actions_1.setLoader)(true));
    dispatch(updateBozzaF24OrdinarioStart());
    if (extraArguments.mock) {
        dispatch((0, general_actions_1.setLoader)(false));
    }
    else {
        const updateBozzaF24OrdinarioRequest = {
            modelloF24Dto: {
                ...parameter,
                bozza: {
                    dataUltimaModifica: moment().toDate()
                }
            },
            id: id
        };
        extraArguments.getItem('jwt').then((jwt) => {
            new api_rest_1.ModelloF24ControllerApi((0, general_configuration_1.default)(api_rest_1.Configuration, extraArguments, undefined, jwt)).updateBozzaModelloF24(updateBozzaF24OrdinarioRequest).then((response) => {
                dispatch(updateBozzaF24OrdinarioSuccess(response));
                dispatch((0, general_actions_1.addSnackbar)('f24.bozzaF24Aggiornata'));
            }).catch(async (error) => {
                console.log(error);
                dispatch(generalError(await (0, helpers_1.formatError)(error)));
            }).finally(() => {
                dispatch((0, general_actions_1.setLoader)(false));
            });
        });
    }
};
exports.updateBozzaF24Ordinario = updateBozzaF24Ordinario;
function getParametriStart() {
    return {
        type: __1.EReduxActionTypes.F24_ORDINARIO_GET_PARAMETRI_START
    };
}
function getParametriSuccess(payload) {
    return {
        type: __1.EReduxActionTypes.F24_ORDINARIO_GET_PARAMETRI_SUCCESS,
        payload
    };
}
function getParametriPerRipetiF24OrdinarioSuccess(payload) {
    return {
        type: __1.EReduxActionTypes.F24_ORDINARIO_GET_PARAMETRI_PER_RIPETI_SUCCESS,
        payload
    };
}
const getParametriF24 = (ripeti) => async (dispatch, _, extraArguments) => {
    dispatch((0, general_actions_1.setLoader)(true));
    dispatch(getParametriStart());
    if (extraArguments.mock) {
        dispatch((0, general_actions_1.setLoader)(false));
    }
    else {
        extraArguments.getItem('jwt').then((jwt) => {
            new api_rest_1.ModelloF24ControllerApi((0, general_configuration_1.default)(api_rest_1.Configuration, extraArguments, undefined, jwt)).parametersModelloF24().then((response) => {
                var _a;
                dispatch(ripeti ? getParametriPerRipetiF24OrdinarioSuccess((0, api_rest_1.F24ParametriDtoFromJSON)(response)) : getParametriSuccess(response));
                ((_a = response.rapporti) === null || _a === void 0 ? void 0 : _a.length) === 0 && dispatch((0, general_actions_1.setNoRapporti)({ type: general_types_1.TypeNoRapporti.F24 }));
                if (extraArguments.platform == 'mobile') {
                    !ripeti && dispatch(resetMotiviMobile());
                }
            }).catch(async (error) => {
                dispatch(generalError(await (0, helpers_1.formatError)(error)));
            }).finally(() => {
                dispatch((0, general_actions_1.setLoader)(false));
            });
        });
    }
};
exports.getParametriF24 = getParametriF24;
function controlloF24OrdinarioStart() {
    return {
        type: __1.EReduxActionTypes.F24_ORDINARIO_CHECK_F24_ORDINARIO_START
    };
}
function controlloF24OrdinarioSuccess(payload) {
    return {
        type: __1.EReduxActionTypes.F24_ORDINARIO_CHECK_F24_ORDINARIO_SUCCESS,
        payload
    };
}
const controlloF24Ordinario = (value, tipoModello) => async (dispatch, getState, extraArguments) => {
    dispatch((0, general_actions_1.setLoader)(true));
    dispatch(controlloF24OrdinarioStart());
    if (extraArguments.mock) {
        dispatch((0, general_actions_1.setLoader)(false));
    }
    else {
        extraArguments.getItem('jwt').then((jwt) => {
            let modelloF24;
            if (value) {
                modelloF24 = value;
            }
            else {
                const state = getState().f24;
                if (tipoModello === 'STANDARD') {
                    modelloF24 = (0, f24_selectors_1.buildF24Ordinario)(state);
                }
                else if (tipoModello === 'ACCISE') {
                    modelloF24 = (0, f24_selectors_1.buildF24Accise)(state);
                }
                else if (tipoModello === 'IDENTIFICATIVI') {
                    modelloF24 = (0, f24_selectors_1.buildF24Elide)(state);
                }
                else {
                    modelloF24 = (0, f24_selectors_1.buildF24Semplificato)(state);
                }
            }
            const requestParameters = {
                modelloF24Dto: modelloF24
            };
            new api_rest_1.ModelloF24ControllerApi((0, general_configuration_1.default)(api_rest_1.Configuration, extraArguments, undefined, jwt)).checkModelloF24(requestParameters).then((response) => {
                dispatch(controlloF24OrdinarioSuccess(response));
            }).catch(async (error) => {
                dispatch(generalError(await (0, helpers_1.formatError)(error)));
            }).finally(() => {
                dispatch((0, general_actions_1.setLoader)(false));
            });
        });
    }
};
exports.controlloF24Ordinario = controlloF24Ordinario;
function getInfoDispositivaF24OrdinarioStart() {
    return {
        type: __1.EReduxActionTypes.F24_ORDINARIO_GET_INFO_DISPOSITIVA_START
    };
}
function getInfoDispositivaF24OrdinarioSuccess(payload) {
    return {
        type: __1.EReduxActionTypes.F24_ORDINARIO_GET_INFO_DISPOSITIVA_SUCCESS,
        payload
    };
}
const getInfoDispositivaF24Ordinario = (idDispositiva, eseguiInit, chiamataUscente, offline, tipologia) => async (dispatch, _, extraArguments) => {
    dispatch((0, general_actions_1.setLoader)(true));
    dispatch(getInfoDispositivaF24OrdinarioStart());
    if (extraArguments.mock) {
        dispatch((0, general_actions_1.setLoader)(false));
    }
    else {
        extraArguments.getItem('jwt').then((jwt) => {
            const requestParameters = {
                codiceFunzioneF24: tipologia || 'f24semplificato',
                idDispositiva,
                chiamataUscente,
                eseguiInit,
                offline: !!offline
            };
            new api_rest_1.ModelloF24ControllerApi((0, general_configuration_1.default)(api_rest_1.Configuration, extraArguments, undefined, jwt)).authenticationInformationModelloF24(requestParameters).then((response) => {
                dispatch(getInfoDispositivaF24OrdinarioSuccess(response));
            }).catch(async (error) => {
                dispatch(generalError(await (0, helpers_1.formatError)(error)));
            }).finally(() => {
                dispatch((0, general_actions_1.setLoader)(false));
            });
        });
    }
};
exports.getInfoDispositivaF24Ordinario = getInfoDispositivaF24Ordinario;
function autorizzaF24OrdinarioStart() {
    return {
        type: __1.EReduxActionTypes.F24_ORDINARIO_AUTORIZZA_START
    };
}
function autorizzaF24OrdinarioSuccess(payload) {
    return {
        type: __1.EReduxActionTypes.F24_ORDINARIO_AUTORIZZA_SUCCESS,
        payload
    };
}
const autorizzaF24Semplificato = (idDispositiva, credenziale, f24) => async (dispatch, getState, extraArguments) => {
    (0, exports.autorizzaF24Ordinario)(idDispositiva, credenziale, 'f24semplificato')(dispatch, getState, extraArguments);
};
exports.autorizzaF24Semplificato = autorizzaF24Semplificato;
const autorizzaF24Ordinario = (idDispositiva, credenziale, tipologia) => async (dispatch, _, extraArguments) => {
    dispatch((0, general_actions_1.setLoader)(true));
    dispatch(autorizzaF24OrdinarioStart());
    if (extraArguments.mock) {
        dispatch((0, general_actions_1.setLoader)(false));
    }
    else {
        extraArguments.getItem('jwt').then((jwt) => {
            const requestParameters = {
                codiceFunzioneF24: tipologia,
                idDispositiva,
                credenzialeDispositivaDto: credenziale
            };
            new api_rest_1.ModelloF24ControllerApi((0, general_configuration_1.default)(api_rest_1.Configuration, extraArguments, undefined, jwt)).authorizeModelloF24(requestParameters).then((response) => {
                dispatch(autorizzaF24OrdinarioSuccess(response));
                extraArguments.sendEventToMatomo(tipologia.toUpperCase(), `esito dispositiva ${tipologia.toUpperCase()} ${response.stato}`, 'ESITO_DISPOSITIVA');
            }).catch(async (error) => {
                dispatch(generalError(await (0, helpers_1.formatError)(error), false, extraArguments.sendEventToMatomo, tipologia.toUpperCase(), 'ESITO_DISPOSITIVA'));
            }).finally(() => {
                dispatch((0, general_actions_1.setLoader)(false));
            });
        });
    }
};
exports.autorizzaF24Ordinario = autorizzaF24Ordinario;
function getInfoRevocaF24OrdinarioStart() {
    return {
        type: __1.EReduxActionTypes.F24_ORDINARIO_GET_INFO_REVOCA_START
    };
}
function getInfoRevocaF24OrdinarioSuccess(payload) {
    return {
        type: __1.EReduxActionTypes.F24_ORDINARIO_GET_INFO_REVOCA_SUCCESS,
        payload
    };
}
const getInfoRevocaF24Ordinario = (idDispositiva, eseguiInit, chiamataUscente, offline) => async (dispatch, _, extraArguments) => {
    dispatch((0, general_actions_1.setLoader)(true));
    dispatch(getInfoRevocaF24OrdinarioStart());
    if (extraArguments.mock) {
        dispatch((0, general_actions_1.setLoader)(false));
    }
    else {
        const requestParameters = {
            idDispositiva,
            chiamataUscente,
            eseguiInit,
            offline: !!offline
        };
        extraArguments.getItem('jwt').then((jwt) => {
            new api_rest_1.ModelloF24ControllerApi((0, general_configuration_1.default)(api_rest_1.Configuration, extraArguments, undefined, jwt)).informazioniAutenticazioneRevocaModelloF24(requestParameters).then((response) => {
                dispatch(getInfoRevocaF24OrdinarioSuccess(response));
            }).catch(async (error) => {
                dispatch(generalError(await (0, helpers_1.formatError)(error)));
            }).finally(() => {
                dispatch((0, general_actions_1.setLoader)(false));
            });
        });
    }
};
exports.getInfoRevocaF24Ordinario = getInfoRevocaF24Ordinario;
function autorizzaRevocaF24OrdinarioStart() {
    return {
        type: __1.EReduxActionTypes.F24_ORDINARIO_AUTORIZZA_REVOCA_START
    };
}
function autorizzaRevocaF24OrdinarioSuccess(payload) {
    return {
        type: __1.EReduxActionTypes.F24_ORDINARIO_AUTORIZZA_REVOCA_SUCCESS,
        payload
    };
}
const autorizzaRevocaF24Ordinario = (idDispositiva, credenziale, f24) => async (dispatch, _, extraArguments) => {
    var _a, _b;
    dispatch((0, general_actions_1.setLoader)(true));
    dispatch(autorizzaRevocaF24OrdinarioStart());
    if (extraArguments.mock) {
        dispatch((0, general_actions_1.setLoader)(false));
    }
    else {
        const requestParameters = {
            modelloF24RevocaRequestIn: {
                annoInserimento: (_a = f24.campiF24SP) === null || _a === void 0 ? void 0 : _a.annoRiferimento,
                codiceRapporto: f24.codiceRapporto,
                progressivoInserimento: (_b = f24.campiF24SP) === null || _b === void 0 ? void 0 : _b.progressivoInserimento,
                tipologia: f24.tipologia
            }
        };
        extraArguments.getItem('jwt').then((jwt) => {
            new api_rest_1.ModelloF24ControllerApi((0, general_configuration_1.default)(api_rest_1.Configuration, extraArguments, undefined, jwt)).operazioneAutenticataModelloF24(requestParameters).then((response) => {
                dispatch(autorizzaRevocaF24OrdinarioSuccess(response));
                extraArguments.sendEventToMatomo(f24.tipologia.toUpperCase(), `esito revoca dispositiva ${f24.tipologia.toUpperCase()}_REVOCA ${response.stato}`, 'REVOCA_DISPOSITIVA');
            }).catch(async (error) => {
                console.log(error);
                dispatch(generalError(await (0, helpers_1.formatError)(error), false, extraArguments.sendEventToMatomo, `${f24.tipologia.toUpperCase()}_REVOCA`, 'REVOCA_DISPOSITIVA'));
            }).finally(() => {
                dispatch((0, general_actions_1.setLoader)(false));
            });
        });
    }
};
exports.autorizzaRevocaF24Ordinario = autorizzaRevocaF24Ordinario;
function getBozzeF24OrdinarioStart() {
    return {
        type: __1.EReduxActionTypes.F24_ORDINARIO_GET_BOZZE_START
    };
}
function getBozzeF24OrdinarioSuccess(payload) {
    return {
        type: __1.EReduxActionTypes.F24_ORDINARIO_GET_BOZZE_SUCCESS,
        payload
    };
}
const getBozzeF24Ordinario = (request) => async (dispatch, _, extraArguments) => {
    dispatch((0, general_actions_1.setLoader)(true));
    dispatch(getBozzeF24OrdinarioStart());
    if (extraArguments.mock) {
        dispatch((0, general_actions_1.setLoader)(false));
    }
    else {
        const getBozzeF24OrdinarioRequest = {
            bozzeInDto: request
        };
        extraArguments.getItem('jwt').then((jwt) => {
            new api_rest_1.ModelloF24ControllerApi((0, general_configuration_1.default)(api_rest_1.Configuration, extraArguments, undefined, jwt)).getBozzeModelloF24(getBozzeF24OrdinarioRequest).then((response) => {
                dispatch(getBozzeF24OrdinarioSuccess(response));
            }).catch(async (error) => {
                dispatch(generalError(await (0, helpers_1.formatError)(error)));
            }).finally(() => {
                dispatch((0, general_actions_1.setLoader)(false));
            });
        });
    }
};
exports.getBozzeF24Ordinario = getBozzeF24Ordinario;
function addBozzaF24OrdinarioStart() {
    return {
        type: __1.EReduxActionTypes.F24_ORDINARIO_ADD_BOZZA_START
    };
}
function addBozzaF24OrdinarioSuccess(payload) {
    return {
        type: __1.EReduxActionTypes.F24_ORDINARIO_ADD_BOZZA_SUCCESS,
        payload
    };
}
const addBozzaF24Ordinario = (parameter) => async (dispatch, _, extraArguments) => {
    dispatch((0, general_actions_1.setLoader)(true));
    dispatch(addBozzaF24OrdinarioStart());
    if (extraArguments.mock) {
        dispatch((0, general_actions_1.setLoader)(false));
    }
    else {
        const addBozzaF24OrdinarioRequest = {
            modelloF24Dto: {
                ...parameter,
                bozza: {
                    dataUltimaModifica: moment().toDate()
                }
            }
        };
        extraArguments.getItem('jwt').then((jwt) => {
            new api_rest_1.ModelloF24ControllerApi((0, general_configuration_1.default)(api_rest_1.Configuration, extraArguments, undefined, jwt)).addBozzaModelloF24(addBozzaF24OrdinarioRequest).then((response) => {
                dispatch(addBozzaF24OrdinarioSuccess(response));
                dispatch((0, general_actions_1.addSnackbar)('f24.nuovaBozzaF24Salvata'));
            }).catch(async (error) => {
                console.log(error);
                dispatch(generalError(await (0, helpers_1.formatError)(error)));
            }).finally(() => {
                dispatch((0, general_actions_1.setLoader)(false));
            });
        });
    }
};
exports.addBozzaF24Ordinario = addBozzaF24Ordinario;
function delBozzaF24OrdinarioStart() {
    return {
        type: __1.EReduxActionTypes.F24_ORDINARIO_DEL_BOZZA_START
    };
}
function delBozzaF24OrdinarioSuccess(id) {
    return {
        type: __1.EReduxActionTypes.F24_ORDINARIO_DEL_BOZZA_SUCCESS,
        payload: id
    };
}
const delBozzaF24Ordinario = (id) => async (dispatch, _, extraArguments) => {
    dispatch((0, general_actions_1.setLoader)(true));
    dispatch(delBozzaF24OrdinarioStart());
    if (extraArguments.mock) {
        dispatch((0, general_actions_1.setLoader)(false));
    }
    else {
        const delBozzaF24OrdinarioRequest = {
            id
        };
        extraArguments.getItem('jwt').then((jwt) => {
            new api_rest_1.ModelloF24ControllerApi((0, general_configuration_1.default)(api_rest_1.Configuration, extraArguments, undefined, jwt)).deleteBozzaModelloF24(delBozzaF24OrdinarioRequest).then(() => {
                dispatch(delBozzaF24OrdinarioSuccess(id));
                dispatch((0, general_actions_1.addSnackbar)('f24.bozzaEliminataConSuccesso'));
            }).catch(async (error) => {
                dispatch(generalError(await (0, helpers_1.formatError)(error)));
            }).finally(() => {
                dispatch((0, general_actions_1.setLoader)(false));
            });
        });
    }
};
exports.delBozzaF24Ordinario = delBozzaF24Ordinario;
function esportaDettaglioF24PDFStart() {
    return {
        type: __1.EReduxActionTypes.F24_ESPORTA_F24_PDF_START
    };
}
function esportaDettaglioF24PDFSuccess(payload) {
    return {
        type: __1.EReduxActionTypes.F24_ESPORTA_F24_PDF_SUCCESS,
        payload
    };
}
const esportaDettaglioF24PDF = (share, title, message) => async (dispatch, getState, extraArguments) => {
    const f24Reducer = getState().f24;
    dispatch((0, general_actions_1.setLoader)(true));
    dispatch(esportaDettaglioF24PDFStart());
    if (extraArguments.mock) {
        dispatch((0, general_actions_1.setLoader)(false));
    }
    else {
        const filterF24 = (0, f24_selectors_1.buildFilterExportDettaglioF24)(f24Reducer);
        const esportaDettaglioF24PDFRequest = {
            dettaglioRequest: filterF24
        };
        extraArguments.getItem('jwt').then((jwt) => {
            new api_rest_1.ModelloF24ControllerApi((0, general_configuration_1.default)(api_rest_1.Configuration, extraArguments, undefined, jwt, 'application/pdf')).stampaPDF(esportaDettaglioF24PDFRequest).then(async (response) => {
                if (extraArguments.platform === 'desktop') {
                    (0, helpers_1.hadlePdfResponse)(response, (url) => dispatch((0, general_actions_1.popUpBlockedPdf)(url)));
                }
                if (extraArguments.platform === 'mobile') {
                    (0, helpers_1.download_sharePDF)(extraArguments, 'dettaglio_f24.pdf', response, share, title, message);
                }
                dispatch(esportaDettaglioF24PDFSuccess(response));
            }).catch(async (error) => {
                try {
                    dispatch(generalError(await (0, helpers_1.formatError)(error)));
                }
                catch (e) {
                    console.log(e);
                }
            }).finally(() => {
                dispatch((0, general_actions_1.setLoader)(false));
            });
        });
    }
};
exports.esportaDettaglioF24PDF = esportaDettaglioF24PDF;
function esportaQuietanzaF24PDFStart() {
    return {
        type: __1.EReduxActionTypes.F24_ESPORTA_QUIETANZA_PDF_START
    };
}
function esportaQuietanzaF24PDFSuccess(payload) {
    return {
        type: __1.EReduxActionTypes.F24_ESPORTA_QUIETANZA_PDF_SUCCESS,
        payload
    };
}
const esportaQuietanzaF24PDF = (filtro, share, title, message) => async (dispatch, getState, extraArguments) => {
    const pagamentiReducer = getState().pagamenti;
    dispatch((0, general_actions_1.setLoader)(true));
    dispatch(esportaQuietanzaF24PDFStart());
    if (extraArguments.mock) {
        dispatch((0, general_actions_1.setLoader)(false));
    }
    else {
        const filterF24 = filtro !== null && filtro !== void 0 ? filtro : (0, f24_selectors_1.buildFilterExportQuietanzaF24)(pagamentiReducer);
        const esportaDettaglioF24PDFRequest = {
            dettaglioRequest: filterF24
        };
        extraArguments.getItem('jwt').then((jwt) => {
            new api_rest_1.ModelloF24ControllerApi((0, general_configuration_1.default)(api_rest_1.Configuration, extraArguments, undefined, jwt, 'application/pdf')).stampaQuietanza(esportaDettaglioF24PDFRequest).then(async (response) => {
                if (extraArguments.platform === 'desktop') {
                    (0, helpers_1.hadlePdfResponse)(response, (url) => dispatch((0, general_actions_1.popUpBlockedPdf)(url)));
                }
                if (extraArguments.platform === 'mobile') {
                    (0, helpers_1.download_sharePDF)(extraArguments, 'quietanza_f24.pdf', response, share, title, message);
                }
                dispatch(esportaQuietanzaF24PDFSuccess(response));
            }).catch(async (error) => {
                try {
                    dispatch(generalError(await (0, helpers_1.formatError)(error)));
                }
                catch (e) {
                    console.log(e);
                }
            }).finally(() => {
                dispatch((0, general_actions_1.setLoader)(false));
            });
        });
    }
};
exports.esportaQuietanzaF24PDF = esportaQuietanzaF24PDF;
function getCodiciEnteF24SemplificatoStart() {
    return {
        type: __1.EReduxActionTypes.F24_SEMPLIFICATO_GET_CODICI_ENTE_START
    };
}
function getCodiciEnteF24SemplificatoSuccess(payload) {
    return {
        type: __1.EReduxActionTypes.F24_SEMPLIFICATO_GET_CODICI_ENTE_SUCCESS,
        payload
    };
}
const getCodiciEnteF24Semplificato = (provincia) => async (dispatch, _, extraArguments) => {
    dispatch((0, general_actions_1.setLoader)(true));
    dispatch(getCodiciEnteF24SemplificatoStart());
    if (extraArguments.mock) {
        dispatch((0, general_actions_1.setLoader)(false));
    }
    else {
        const requestParameters = {
            provincia
        };
        extraArguments.getItem('jwt').then((jwt) => {
            new api_rest_1.ModelloF24ControllerApi((0, general_configuration_1.default)(api_rest_1.Configuration, extraArguments, undefined, jwt)).codiciComuni(requestParameters).then((response) => {
                dispatch(getCodiciEnteF24SemplificatoSuccess(response));
            }).catch(async (error) => {
                dispatch(generalError(await (0, helpers_1.formatError)(error)));
            }).finally(() => {
                dispatch((0, general_actions_1.setLoader)(false));
            });
        });
    }
};
exports.getCodiciEnteF24Semplificato = getCodiciEnteF24Semplificato;
function getCodiciUfficioF24Start() {
    return {
        type: __1.EReduxActionTypes.F24_ORDINARIO_GET_CODICI_UFFICIO_START
    };
}
function getCodiciUfficioF24Success(payload) {
    return {
        type: __1.EReduxActionTypes.F24_ORDINARIO_GET_CODICI_UFFICIO_SUCCESS,
        payload
    };
}
const getCodiciUfficioF24 = (provincia) => async (dispatch, _, extraArguments) => {
    dispatch((0, general_actions_1.setLoader)(true));
    dispatch(getCodiciUfficioF24Start());
    if (extraArguments.mock) {
        dispatch((0, general_actions_1.setLoader)(false));
    }
    else {
        const requestParameters = {
            provincia
        };
        extraArguments.getItem('jwt').then((jwt) => {
            new api_rest_1.ModelloF24ControllerApi((0, general_configuration_1.default)(api_rest_1.Configuration, extraArguments, undefined, jwt)).codiciUffici(requestParameters).then((response) => {
                dispatch(getCodiciUfficioF24Success(response));
            }).catch(async (error) => {
                dispatch(generalError(await (0, helpers_1.formatError)(error)));
            }).finally(() => {
                dispatch((0, general_actions_1.setLoader)(false));
            });
        });
    }
};
exports.getCodiciUfficioF24 = getCodiciUfficioF24;
/*function initDocumentSessionF24Start(): IF24InitDocumentSessionF24Start {
  return {
    type: EReduxActionTypes.F24_INIT_DOCUMENT_SESSION_F24_START
  };
}

function initDocumentSessionF24Success(payload: InitDocumentSessionResponseDto): IF24InitDocumentSessionF24Success {
  return {
    type: EReduxActionTypes.F24_INIT_DOCUMENT_SESSION_F24_SUCCESS,
    payload: payload
  };
}

export const initDocumentSessionF24 = (): ThunkAction<
  void,
  State,
  any,
  TF24ActionTypes
> => async (dispatch, _, extraArguments) => {

  dispatch(setLoader(true));

  dispatch(initDocumentSessionF24Start());

  if (extraArguments.mock) {

    import('../../mock//f24_scanner_init.json').then(init => {
      dispatch(initDocumentSessionF24Success(init));
      dispatch(setLoader(false));
    });

  } else {
    new DocumentSessionApi(getConfiguration(ConfigurationF24, extraArguments, '', '', undefined, 'documentScanner', undefined, true) as ConfigurationF24).apiDocumentSessionInitGet().then((response: InitDocumentSessionResponseDto) => {
      dispatch(initDocumentSessionF24Success(response));
    }).catch(async (error: IGeneralState) => {
      dispatch(generalError(await formatError(error)));
    }).finally(() => {
      dispatch(setLoader(false));
    });
  }
};

function getInfoDocumentSessionTokenF24Start(): IF24GetInfoDocumentSessionTokenF24Start {
  return {
    type: EReduxActionTypes.F24_GET_INFO_DOCUMENT_SESSION_TOKEN_F24_START
  };
}

function getInfoDocumentSessionTokenF24Success(payload: DocumentSessionInfoResponseDto): IF24GetInfoDocumentSessionTokenF24Success {
  return {
    type: EReduxActionTypes.F24_GET_INFO_DOCUMENT_SESSION_TOKEN_F24_SUCCESS,
    payload: payload
  };
}

export const getInfoDocumentSessionTokenF24 = (showLoader: boolean = true): ThunkAction<
  void,
  State,
  any,
  TF24ActionTypes
> => async (dispatch, getState, extraArguments) => {

  const f24 = getState().f24;
  const token = f24.documentSessionInitF24Result?.token;

  if (!token) {
    return;
  }

  showLoader && dispatch(setLoader(true));

  dispatch(getInfoDocumentSessionTokenF24Start());

  if (extraArguments.mock) {

    import('../../mock//f24_scanner_info.json').then(info => {
      dispatch(getInfoDocumentSessionTokenF24Success(info as unknown as DocumentSessionInfoResponseDto));
      showLoader && dispatch(setLoader(false));
    });

  } else {

    const request: ApiDocumentSessionTokenInfoGetRequest = {
      token
    };

    new DocumentSessionApi(getConfiguration(ConfigurationF24, extraArguments, '', '', undefined, 'documentScanner', undefined, true) as ConfigurationF24).apiDocumentSessionTokenInfoGet(request).then((response: DocumentSessionInfoResponseDto) => {
      dispatch(getInfoDocumentSessionTokenF24Success(response));
    }).catch(async (error: IGeneralState) => {
      dispatch(generalError(await formatError(error)));
    }).finally(() => {
      showLoader && dispatch(setLoader(false));
    });
  }
};

function getDownloadDocumentSessionTokenF24Start(): IF24GetDownloadDocumentSessionTokenF24Start {
  return {
    type: EReduxActionTypes.F24_GET_DOWNLOAD_DOCUMENT_SESSION_TOKEN_F24_START
  };
}

function getDownloadDocumentSessionTokenF24Success(payload: string): IF24GetDownloadDocumentSessionTokenF24Success {
  return {
    type: EReduxActionTypes.F24_GET_DOWNLOAD_DOCUMENT_SESSION_TOKEN_F24_SUCCESS,
    payload: payload
  };
}


export const getDownloadDocumentSessionTokenF24 = (): ThunkAction<
  void,
  State,
  any,
  TF24ActionTypes
> => async (dispatch, getState, extraArguments) => {

  const f24 = getState().f24;
  const token = f24.documentSessionInitF24Result?.token;

  if (!token) {
    return;
  }

  dispatch(setLoader(true));

  dispatch(getDownloadDocumentSessionTokenF24Start());

  if (extraArguments.mock) {

    dispatch(getDownloadDocumentSessionTokenF24Success(f24ScannerDownloadBase64));
    dispatch(setLoader(false));

  } else {

    const request: ApiDocumentSessionTokenDownloadGetRequest = {
      token
    };

    new DocumentSessionApi(getConfiguration(ConfigurationF24, extraArguments, '', '', undefined, 'documentScanner', undefined, true) as ConfigurationF24).apiDocumentSessionTokenDownloadGet(request).then(async (response: Blob) => {

      const blob = new Blob([response], { type: 'application/jpeg' });
      await blobDataToString(blob).then(blobConvertedTostring => {
        dispatch(getDownloadDocumentSessionTokenF24Success(blobConvertedTostring));
      }).catch(async (error: IGeneralState) => {
        dispatch(generalError(await formatError(error)));
      });

    }).catch(async (error: IGeneralState) => {
      dispatch(generalError(await formatError(error)));
    }).finally(() => {
      dispatch(setLoader(false));
    });
  }
};

export function resetDocumentSessionF24(keepImage: boolean = false): IF24ResetDocumentSessionF24 {
  return {
    type: EReduxActionTypes.F24_RESET_DOCUMENT_SESSION_F24,
    keepImage
  };
};*/
